/**
 * @license lucide-react v1.59.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.mjs';

const __iconData = {
  name: "face-slightly-frowning",
  size: 24,
  node: [
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }],
    ["path", { d: "M9 16a5 5 0 016 0", key: "34mdxb" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["frown"]
};
__iconData.node;
const FaceSlightlyFrowning = createLucideIcon(__iconData);

export { __iconData, FaceSlightlyFrowning as default };
//# sourceMappingURL=face-slightly-frowning.mjs.map
